<template>
  <div v-if="show" class="page-loader">
  <b-spinner class="spinner" variant="primary" label="Spinning"></b-spinner>
</div>
</template>

<script>
export default {
	name: 'page-loader',
	data(){
		return {
      show: true
		}
	},
	methods: {
    
	},
  mounted(){
  }
}
</script>

<style>
  .page-loader {
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: white;
    z-index: 1000;
  }
</style>